import React, { useState, useEffect } from "react";
import { Navbar, Container, Modal, Nav, Button } from "react-bootstrap";
import { INFO, CHEVRON_RIGHT } from "../iconsSVG/IconsSVG";
import AuthControl from "../auth/authControl";
import "./menu.css";
import { NavLink, useNavigate } from "react-router-dom";

function Menu({
  activeTab,
  setActiveTab,
  activeInnerTab,
  setActiveInnerTab
}) {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);
  const [openDescarga, setOpenDescarga] = useState(false);
  const [openBuscador, setOpenBuscador] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const cerrarMenuCompleto = () => {
    setMenuOpen(false);
    setOpenDescarga(false);
    setOpenBuscador(false);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* ================= CABECERA SUPERIOR ================= */}
      <Navbar 
        className="menu-fondo-principal flex-column flex-md-row position-fixed z-3">
        <Container fluid
          className="p-0 m-0 ps-md-4"
        >
          <Nav className="m-0 p-0 mt-1 d-flex w-100" 
            style={{ marginLeft: "-1px" }}
          >
            {/* IZQUIERDA */}
            {! isMobile && (
              <div className="m-0 p-0 ps-1 menu-fondo w-100 d-flex flex-column flex-md-row align-items-center">
                <Nav.Link
                  as={NavLink}
                  to="/"
                  style={{
                    color: "#ffffff",
                    fontSize: "14px"
                  }}
                  className="m-1 p-0 pe-3 ps-0 nav-link-hover"
                >
                  BOLETÍN OFICIAL DE LA PROPIEDAD INDUSTRIAL
                </Nav.Link>

                <Nav.Link
                  href="#"
                  className="m-1 p-0 pe-4 invisible"
                >
                  CONTACTO
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/subscripcion-boletin"
                  style={{
                    color: "#ffffff",
                    fontSize: "14px"
                  }}
                  className="m-1 p-0 pe-3"
                >
                  <span className="nav-link-hover">
                    SUSCRIPCIÓN A BOLETIN
                  </span>
                  <Button
                    style={{
                      backgroundColor: "transparent",
                      border: "none"
                    }}
                    onClick={handleShow}
                    className="m-0 p-0"
                  >
                    <div className="fondo-blanco-icono">
                      <INFO color_icono="#203C77" color_fondo="white" />
                    </div>
                  </Button>
                </Nav.Link>
              </div>
              )
            }
            {/* 🔥 BOTÓN HAMBURGUESA */}
            {isMobile && (
              <div
                className={`me-1 menu-mobile-icon d-flex justify-content-end ${menuOpen ? "open" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <div className="hamburger">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="menu-text">
                  {menuOpen ? "CERRAR" : "MENÚ"}
                </span>
              </div>
            )}

            <Modal show={show} onHide={handleClose} dialogClassName="p-3 mt-5">
              <Modal.Header closeButton />
              <Modal.Body>
                Suscripción para recibir vía correo electrónico los enlaces a
                las publicaciones del Boletín Oficial de la Propiedad Industrial
                en formato PDF.
              </Modal.Body>
            </Modal>

          </Nav>
        </Container>

        <AuthControl />
      </Navbar>

      {/* ================= MENÚ MÓVIL ================= */}
      {isMobile && (
        <>
          {/* Overlay */}
          {menuOpen && (
            <div
              className="menu-overlay"
              onClick={cerrarMenuCompleto}
            />
          )}

          {/* Panel lateral */}
          <div className={`mobile-menu-panel ${menuOpen ? "open" : ""}`}>

            <div className="mobile-menu-header">
              BOLETÍN OFICIAL DE LA PROPIEDAD INDUSTRIAL
            </div>

            {/* DESCARGA */}
            <div className={`menu-item ${openDescarga ? "open" : ""}`}>
              <div
                className="menu-title"
                onClick={() => setOpenDescarga(!openDescarga)}
              >
                <span>Descarga de publicaciones</span>
                <span className={`arrow ${openDescarga ? "open" : ""}`}>
                <CHEVRON_RIGHT></CHEVRON_RIGHT> {/* &gt; */}
                </span>
              </div>

              {openDescarga && (
                <div className="submenu">
                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("descarga");
                      setActiveInnerTab("Tomo1");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 1: Marcas y otros signos distintivos</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>

                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("descarga");
                      setActiveInnerTab("Tomo2");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 2: Invenciones</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>

                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("descarga");
                      setActiveInnerTab("Tomo3");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 3: Diseños industriales</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* BUSCADOR */}
            <div className={`menu-item ${openBuscador ? "open" : ""}`}>
              <div
                className="menu-title"
                onClick={() => setOpenBuscador(!openBuscador)}
              >
                <span>Buscador de publicaciones</span>
                <span className={`arrow ${openBuscador ? "open" : ""}`}>
                  <CHEVRON_RIGHT></CHEVRON_RIGHT> {/* &gt; */}
                </span>
              </div>

              {openBuscador && (
                <div className="submenu">
                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("buscador");
                      setActiveInnerTab("Tomo1");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 1: Marcas y otros signos distintivos</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>

                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("buscador");
                      setActiveInnerTab("Tomo2");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 2: Invenciones</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>

                  <div
                    className="submenu-item"
                    onClick={() => {
                      navigate("/");
                      setActiveTab("buscador");
                      setActiveInnerTab("Tomo3");
                      cerrarMenuCompleto();
                    }}
                  >
                    <span>Tomo 3: Diseños industriales</span>
                    <span className="ms-2 arrow">
                      <CHEVRON_RIGHT></CHEVRON_RIGHT>
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* BOPI */}
            <div className="menu-item">
              <div
                className="menu-title "
                onClick={() => {
                  navigate("/");
                  setActiveTab("historico");
                  cerrarMenuCompleto();
                }}
              >
                <span>BOPI histórico</span>
                <span className="arrow">
                  <CHEVRON_RIGHT></CHEVRON_RIGHT>
                </span>
              </div>
            </div>

            {/* AYUDA */}
            <div className="menu-item">
              <div
                className="menu-title"
                onClick={() => {
                  navigate("/");
                  setActiveTab("ayuda");
                  cerrarMenuCompleto();
                }}
              >
                <span>Ayuda</span>
                <span className="arrow">
                  <CHEVRON_RIGHT></CHEVRON_RIGHT>
                </span>
              </div>
            </div>

            <div className="mobile-menu-header">
              SUSCRIPCIÓN A BOLETIN              
            </div>

            {/* Suscripción al BOPI */}
            <Nav.Link
                as={NavLink}
                to="/subscripcion-boletin"
                onClick={() => {
                  cerrarMenuCompleto();
                }}
                // style={{
                //   color: "#ffffff",
                //   fontSize: "14px"
                // }}
                // className="m-1 p-0 pe-3"
            >              

              <div className="menu-item">
                <div
                  className="menu-title"
                  // onClick={() => {
                  //   setActiveTab("ayuda");
                  //   cerrarMenuCompleto();
                  // }}
                >
                  <span>Suscripción al BOPI</span>
                  <span className="arrow">
                    <CHEVRON_RIGHT></CHEVRON_RIGHT>
                  </span>
                </div>
              </div>
            </Nav.Link>
          </div>
        </>
      )}
      <br />
      <br />

    </>
  );
}

export default Menu;